export default __webpack_public_path__ + "assets/images/50aed5b3e501615d600c4614d1c340c0.png";